var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-access"},[_c('h2',[_vm._v("暂无可访问菜单")]),_c('p',[_vm._v("请联系管理员分配菜单权限。")])])}]

export { render, staticRenderFns }